<template>
  <VTableLocal
    v-if="hasPermission('members.sites.view')"
    :iconHeader="hasPermission('members.sites.add') ? 'add' : null"
    :items="sites"
    :itemActions="btnAction"
    :headers="tableHeaders"
    :centerColumns="['action']"
    :isSearchable="false"
    filterName="clientMemberSites"
    newSearchBar
    :title="$t('sites.pageName')"
    @iconAction="onClickConfirmRemove"
    @click-icon-header="onClickShowModal"
  />
</template>

<script>
// TODO - {itemActions="actions" when permissions done}
import Vue from 'vue';
import { mapGetters } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import AssociateSiteForm from '@/components/team/AssociateSiteForm';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';

export default {
    components: {
        VTableLocal,
    },
    props: {
        item: {
            type: Object,
            default: () => ({ empty: true }),
        },
        memberId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            sites: [],
            member: {},
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'team',
        ]),
        tableHeaders() {
            return [
                'name',
            ].map(header => ({
                text: this.$t(`forms.labels.${header}`),
                value: header,
            }));
        },
        btnAction() {
            if (this.hasPermission('members.sites.remove')) {
                return [{
                    name: this.$t('forms.btn.delete'),
                    icon: 'delete',
                    mode: 'delete',
                    iconAndTextColor: '#EF4135',
                }];
            }
            return [];
        },
    },
    created() {
        this.getMemberSites();
        this.getMemberInfo();
    },
    methods: {
        onClickShowModal(item) {
            if (item === 'add') {
                this.showAssociateSiteModal();
            } else {
                this.showRevokeSiteModal(item);
            }
        },
        showAssociateSiteModal() {
            this.$root.$emit('showModal', {
                title: this.$t('members.associateSite'),
                component: Vue.component('associateSiteForm', AssociateSiteForm),
                payload: {
                    memberId: this.memberId,
                    clientId: this.$route.params.clientId,
                },
                onConfirm: requestPayload => this.associateMemberRequest(requestPayload),
            });
        },
        onClickConfirmRemove(item) {
            this.$root.$emit('showModal', {
                title: this.$t('members.revokeSite'),
                component: Vue.component('revokeForm', ConfirmForm),
                payload: {
                    msg: this.$t('members.confirmRevokeSite', {
                        site: `${item.name}`,
                        member: `${this.member.firstName} ${this.member.lastName}`,
                    }),
                },
                onConfirm: () => this.revokeSiteToMember(item),
                isForm: false,
            });
        },
        async revokeSiteToMember(site) {
            const { id: siteId, name } = site;
            const { firstName, lastName } = this.member;
            await this.$rq.revokeSiteToMember(this.memberId, siteId);

            this.$toasted.global.toast_success({
                message: this.$t('msg.memberSiteDeleted', {
                    site: `${name}`,
                    member: `${firstName} ${lastName}`,
                }),
            });
            this.getMemberSites();
        },
        async associateMemberRequest(requestPayload) {
            const site = { siteId: requestPayload.id };
            const { id, firstName, lastName } = this.member;

            await this.$rq.associateMemberToSite(id, site);
            this.$toasted.global.toast_success({
                message: this.$t('msg.siteAssociated', {
                    site: requestPayload.name,
                    member: `${firstName} ${lastName}`,
                }),
            });
            this.getMemberSites();
        },

        async getMemberSites() {
            if (this.memberId) {
                const { data } = await this.$rq.getMemberSites(this.memberId);
                this.sites = data;
            }
        },
        handleSearch(search) {
            this.queryParams = {
                ...this.queryParams,
                search,
            };
            this.getMemberSites();
        },
        async getMemberInfo() {
            if (this.memberId) {
                const { data } = await this.$rq.getMemberInfo(this.memberId);
                this.member = data;
            }
        },
    },
};
</script>
